import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const TextInput = memo(
  ({
    name,
    category,
    pro,
    con,
    label,
    score,
    value,
    required = false,
    onChange,
    type = 'text',
    error,
    ...props
  }) => {
    const handleChange = useCallback(
      ({ target }) => {
        onChange({
          target: { name, value: target.value, category, pro: 'asd', con },
        });
      },
      [category, con, name, onChange],
    );

    const componentCls = classNames(
      'flex flex-col font-medium flex-1 relative w-none lg:w-96',
      {
        'mb-6': required && error?.length,
      },
    );

    const errorCls = classNames(
      'absolute -bottom-0 ml-4 text-xs text-red-600 transition duration-300',
      {
        'opacity-0': !error?.length,
        'opacity-100': error?.length,
      },
    );

    return (
      <div className={componentCls}>
        <div className="absolute px-3 h-full border-r flex items-center">
          <span className="text-slate-600">$</span>
        </div>
        <input
          className="group text-slate-900 pl-10 pr-3 py-3 rounded text-sm outline-none border border-slate-300 focus:border-blue-600 transition-all duration-300"
          id={name}
          name={name}
          value={value}
          onChange={handleChange}
          type={type}
          {...props}
          pattern="[0-9]+"
        />
        <label
          htmlFor={name}
          className="transform -translate-y-[55px] bg-white text-sm mx-3 text-slate-400 self-start transition-all duration-300">
          {label}
          {required && <span className="text-red-400"> *</span>}
        </label>
        {required && <span className={errorCls}>{error}</span>}
      </div>
    );
  },
);

TextInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  score: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  error: PropTypes.string,
  category: PropTypes.string,
  pro: PropTypes.string,
  con: PropTypes.string,
};
